import { render, staticRenderFns } from "./TheRecipientsAddressBook.vue?vue&type=template&id=66212947&scoped=true"
import script from "./TheRecipientsAddressBook.vue?vue&type=script&lang=js"
export * from "./TheRecipientsAddressBook.vue?vue&type=script&lang=js"
import style0 from "./TheRecipientsAddressBook.vue?vue&type=style&index=0&id=66212947&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66212947",
  null
  
)

export default component.exports